import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import Home from './pages/Home';
import Herancas from './pages/Herancas';
import { WhatsAppFloat } from './components/WhatsAppFloat';
import { initTrackersIfConsented } from './utils/tracking';
import './App.css';

function App() {
  useEffect(() => {
    // GDPR: only load trackers if user has previously accepted cookies.
    // initTrackersIfConsented is a stable module import — no deps needed.
    initTrackersIfConsented();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Router>
      <Toaster position="top-right" richColors />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/herancas" element={<Herancas />} />
      </Routes>
      <WhatsAppFloat />
    </Router>
  );
}

export default App;
